module.exports = __webpack_public_path__ + "img/header-memoireRingsRingsets@2x.46b9a5b.jpg";